module.exports = "/_next/static/images/PredictiveAI-a9378b15e7a13df5ac1c74d9d54b8cfa.webp";